module.exports = __webpack_public_path__ + "img/next.548781ff.svg";